import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgUserHeadset = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M12 2a7 7 0 0 0-7 7 3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1V9a5 5 0 1 1 10 0v7.083A2.92 2.92 0 0 1 14.083 19H14a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 1.732-1h.351a4.92 4.92 0 0 0 4.83-4H19a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3 7 7 0 0 0-7-7m1.45 3.275a4 4 0 0 0-4.352.976 1 1 0 0 0 1.452 1.376 2 2 0 0 1 2.836-.067 1 1 0 1 0 1.386-1.442 4 4 0 0 0-1.321-.843Z",
    clipRule: "evenodd"
  }
) }));

export { SvgUserHeadset as default };
//# sourceMappingURL=user-headset.mjs.map
